import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';

function CategoryDropdown({
  onChangeDropdown,
  showLabel = true,
  required = false,
  isDisabled,
  selectedValue,
  isClearable = true,
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const baseUrl = getApiBaseUrl();
        if (!baseUrl) return;
        const response = await axios.get(`${baseUrl}/product/categories`);
        if (response.status === 200 && response.data?.data) {
          const list = response.data.data || [];
          const mapped = list.map((c) => ({
            value: c.CategoryId?.toString(),
            label: c.CategoryName || `Category ${c.CategoryId}`,
            raw: c,
          }));
          setOptions(mapped);
          if (selectedValue) {
            const match = mapped.find((m) => m.value === selectedValue?.toString());
            setSelectedOption(match || null);
          }
        }
      } catch (err) {
        console.error('Failed to load categories', err);
      }
    };
    fetchCategories();
  }, [selectedValue]);

  useEffect(() => {
    if (!selectedValue) {
      setSelectedOption(null);
      return;
    }
    const match = options.find((m) => m.value === selectedValue?.toString());
    setSelectedOption(match || null);
  }, [selectedValue, options]);

  const handleChange = (option) => {
    setSelectedOption(option);
    if (onChangeDropdown) {
      onChangeDropdown(option);
    }
  };

  return (
    <div className="mb-3">
      {showLabel ? (
        <label className="form-label">
          Category
          {required ? <span style={{ color: 'red' }}>*</span> : null}
        </label>
      ) : null}
      <Select
        options={options}
        value={selectedOption}
        onChange={handleChange}
        isClearable={isClearable}
        isDisabled={isDisabled}
        placeholder="Select category"
      />
    </div>
  );
}

export default CategoryDropdown;
